import { Button, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { LinkAccountSelect } from '../../components/LinkAccountSelect';
import PageLayout from '../../components/PageLayout';
import { Account, AccountIntent } from '../../types';
import actions from './actions';

const useStyles: any = makeStyles((theme) => ({
  confirmContainer: {
    margin: theme.spacing(3, 2, 2),
  },
  summary: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2, 2.5),
  },
  bottomContainer: {
    borderTop: `1px solid ${theme.palette.grey['300']}`,
    backgroundColor: theme.palette.grey['100'],
    paddingTop: theme.spacing(2),
  },
}));

type LinkAccountSelectionProps = {
  accounts: Account[];
  selectedAccount: Account;
  accountIntent: AccountIntent;
  getAccountsToLink: () => Promise<any>;
  setSelectedAccount: (account: Account) => void;
};

const LinkAccountSelection = (props: LinkAccountSelectionProps) => {
  const { accounts, accountIntent, getAccountsToLink, selectedAccount, setSelectedAccount } = props;
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch<any>();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [isSubmitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!accountIntent) {
      history.push({
        pathname: '/500',
      });
    }
  }, []);

  const handleConfirmation = () => {
    closeSnackbar();
    setSubmitting(true);

    dispatch(actions.confirmLink(accountIntent.id, selectedAccount?.gcAccountId))
      .then((response: any) => {
        const { payload } = response;
        if (payload.response && payload.response.status !== 200) {
          if (payload.response.data && payload.response.data.message) {
            enqueueSnackbar(payload.response.data.message, {
              anchorOrigin: { vertical: 'top', horizontal: 'center' },
              variant: 'error',
              key: 'shift',
              autoHideDuration: 12000,
            });
          } else {
            history.push({
              pathname: '/500',
            });
          }
        } else {
          history.push({
            pathname: '/link-success',
          });
        }
      })
      .finally(() => setSubmitting(false));
  };

  const handleAccountChange = (account: Account) => {
    setSelectedAccount(account);
  };

  return (
    <PageLayout pageTitle='Confirm link'>
      <Grid className={classes.summary}>
        <Typography variant='h5'> Please select from these business accounts linked to your mobile number below:</Typography>
      </Grid>
      <Grid className={classes.bottomContainer}>
        <Grid>
          <LinkAccountSelect
            accounts={accounts}
            selectedAccount={selectedAccount}
            accountIntent={accountIntent}
            getAccountsToLink={getAccountsToLink}
            onChange={handleAccountChange}
          />
        </Grid>
        <Grid container>
          <Grid item xs={12} className={classes.confirmContainer}>
            <Button
              size='large'
              variant='contained'
              color='primary'
              type='button'
              disabled={isSubmitting && !selectedAccount}
              fullWidth
              data-testid='uia-link'
              onClick={() => handleConfirmation()}
            >
              Link
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </PageLayout>
  );
};

export default LinkAccountSelection;
